<section id="documents">
  <div class="flex-container">
    <div class="flex-row">
      <div class="flex-col-12">
        <h1 class="ui-headline">{{ 'profile.documents.title' | translate }}</h1>
      </div>

      <ng-container *ngIf="allDocuments$ | async as allDocuments">
        <ng-container *ngIf="!showGrowDocs && maxStep < 3 && !customer.has_crowd_investor_account; else showAllDocs">
          <ng-container *ngIf="!customer.has_crowd_investor_account && allDocuments.initialized">
            <div class="flex-col-12 no-documents doc-notification info">
              <span class="icon-i-info"></span> {{ 'profile.documents.empty_documents' | translate }}
            </div>
          </ng-container>
        </ng-container>
        <ng-template #showAllDocs>
          <div class="flex-col-12">
            <div class="doc-tabs">
              <ng-container *ngFor="let tab of visibleTabs">
                <a (click)="setActiveTab(tab)" [ngClass]="{ active: activeTab === tab }">
                  @if (tab === 'general') {
                    {{ 'profile.documents.general' | translate }}
                  } @else if (tab === '3b') {
                    {{ 'productSwitchDropdown.sectionTitle.pdf' | translate }}
                  } @else {
                    {{ 'productSwitchDropdown.sectionTitle.' + tab | translate }}
                  }
                </a>
              </ng-container>
            </div>
            <ng-container *ngIf="!allDocuments.initialized; else showDocs">
              <div class="white-box">
                <div class="loading-docs"></div>
              </div>
            </ng-container>
            <ng-template #showDocs>
              <!-- General docs / Saxo account docs -->
              <div class="white-box" *ngIf="activeTab === 'general'">
                <ul class="document-list">
                  <!-- other docs -->
                  <li *ngFor="let doc of allDocuments.docsGeneral.docs">
                    <a (click)="downloadDocument(doc)">
                      <span>{{ doc.attributes.translated_title }}</span>
                      <span class="icon-i-download"></span>
                    </a>
                  </li>
                  <!-- static docs -->
                  <li *ngFor="let doc of allDocuments.docsStatic.staticGeneralDocs">
                    <a download (click)="downloadStaticDocs(doc)">
                      <span>{{ doc.attributes.title }}</span>
                      <span class="icon-i-download"></span>
                    </a>
                  </li>
                </ul>
              </div>

              <!-- 3B -->
              <div class="white-box" *ngIf="activeTab === '3b'">
                <div class="doc-notification info" *ngIf="customer?.app_location === 'ch' && showTaxWarning3b">
                  <span class="icon-i-info"></span>
                  {{ 'profile.documents.tax_report_avaialble' | translate: { year_for: currentYear - 1, year_now: currentYear } }} <br />
                </div>
                <ul class="document-list">
                  <!-- tax docs -->
                  <li *ngFor="let doc of allDocuments.docs3b.taxDocs" class="tax-reports">
                    <a (click)="downloadDocument(doc)" title="{{ doc.attributes.title }}">
                      <span>{{ doc.attributes.translated_title }}</span>
                      <span class="icon-i-download"></span>
                    </a>
                  </li>
                </ul>
              </div>

              <!-- PDFs -->
              <div class="white-box" *ngIf="activeTab === 'pdf'">
                <ul class="document-list">
                  <ng-container *ngIf="allDocuments.docs3b.reportingDocs.length; else noPDFReport">
                    <li *ngFor="let doc of allDocuments.docs3b.reportingDocs">
                      <a (click)="downloadDocument(doc)" title="{{ doc.attributes.translated_title }}">
                        <span>{{ doc.attributes.translated_title }}</span>
                        <span class="icon-i-download"></span>
                      </a>
                    </li>
                  </ng-container>
                  <ng-template #noPDFReport>
                    <li>
                      {{ 'profile.documents.noPDFReport' | translate }}
                    </li>
                  </ng-template>
                </ul>
              </div>

              <!-- CI -->
              <ng-container *ngIf="activeTab === 'CI'">
                <div *ngIf="allDocuments.docsCI.docs.length" class="white-box">
                  <ul class="document-list">
                    <li *ngFor="let doc of allDocuments.docsCI.docs">
                      <a (click)="downloadDocument(doc)" title="{{ doc.attributes.translated_title }}">
                        <span>{{ doc.attributes.translated_title }}</span>
                        <span class="icon-i-download"></span>
                      </a>
                    </li>
                  </ul>
                </div>

                <div class="white-box" *ngIf="allDocuments.docsStatic.CIUpdates.length">
                  <div class="documents-collapse">
                    <p (click)="collapsedDocuments.updates = !collapsedDocuments.updates">
                      Updates
                      <span [ngClass]="!collapsedDocuments.updates ? 'icon-i-chevron-up' : 'icon-i-chevron-down'"></span>
                    </p>
                    <ul class="document-list" *ngIf="!collapsedDocuments.updates">
                      <li *ngFor="let doc of allDocuments.docsStatic.CIUpdates">
                        <a download (click)="downloadStaticDocs(doc)">
                          <span>{{ doc.attributes.title }}</span>
                          <span class="icon-i-download"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="white-box" *ngIf="allDocuments.docsStatic.agmDocs.length">
                  <div class="documents-collapse">
                    <p (click)="collapsedDocuments.agm = !collapsedDocuments.agm">
                      {{ 'profile.documents.sub-sectionTitle-CI.AGM' | translate }}
                      <span [ngClass]="!collapsedDocuments.agm ? 'icon-i-chevron-up' : 'icon-i-chevron-down'"></span>
                    </p>
                    <ul class="document-list" *ngIf="!collapsedDocuments.agm">
                      <li *ngFor="let doc of allDocuments.docsStatic.agmDocs">
                        <a download (click)="downloadStaticDocs(doc)">
                          <span>{{ doc.attributes.title }}</span>
                          <span class="icon-i-download"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="white-box" *ngIf="allDocuments.docsStatic.egmDocs.length">
                  <div class="documents-collapse">
                    <p (click)="collapsedDocuments.egm = !collapsedDocuments.egm">
                      {{ 'profile.documents.sub-sectionTitle-CI.EGM' | translate }}
                      <span [ngClass]="!collapsedDocuments.egm ? 'icon-i-chevron-up' : 'icon-i-chevron-down'"></span>
                    </p>
                    <ul class="document-list" *ngIf="!collapsedDocuments.egm">
                      <li *ngFor="let doc of allDocuments.docsStatic.egmDocs">
                        <a download (click)="downloadStaticDocs(doc)">
                          <span>{{ doc.attributes.title }}</span>
                          <span class="icon-i-download"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>

              <!-- 3a -->
              <div class="white-box" *ngIf="activeTab === '3a'">
                <div class="doc-notification info" *ngIf="customer?.app_location === 'ch' && showTaxWarning3a">
                  <span class="icon-i-info"></span>
                  {{ 'profile.documents.tax_report_avaialble_3a' | translate: { yearCurrent: currentYear } }} <br />
                </div>
                <div class="filter-tabs">
                  <div class="date-filter">
                    {{ 'profile.documents.3a.filter.date' | translate }}
                    <div class="order-icons">
                      <span
                        class="icon-i-chevron-up"
                        (click)="changeOrderByDate('document_date')"
                        [ngClass]="{ active: dateSort === 'document_date' }"
                      ></span>
                      <span
                        class="icon-i-chevron-down"
                        (click)="changeOrderByDate('-document_date')"
                        [ngClass]="{ active: dateSort === '-document_date' }"
                      ></span>
                    </div>
                  </div>
                  <div class="title-filter">
                    {{ 'profile.documents.3a.filter.title' | translate }}
                    <div class="order-icons">
                      <span
                        class="icon-i-chevron-up"
                        (click)="changeOrderByTitle('document_type')"
                        [ngClass]="{ active: titleSort === 'document_type' }"
                      ></span>
                      <span
                        class="icon-i-chevron-down"
                        (click)="changeOrderByTitle('-document_type')"
                        [ngClass]="{ active: titleSort === '-document_type' }"
                      ></span>
                    </div>
                  </div>
                  <div class="filter-holder">
                    <div id="filter-selected" class="filter-selected" (click)="toggleFilter()">
                      <span class="icon-i-filter-vertical"></span>
                      <p>{{ 'profile.documents.3a.filter.filter-list.' + selectedFilter.key | translate }}</p>
                      <span class="icon-i-chevron-down"></span>
                    </div>
                    <ul class="filter-list" [ngClass]="{ active: showFilter }">
                      <li
                        *ngFor="let option of filterOptions"
                        (click)="changeSelectedFilter(option)"
                        [ngClass]="{ active: selectedFilter.code === option.code }"
                      >
                        {{ 'profile.documents.3a.filter.filter-list.' + option.key | translate }}
                      </li>
                    </ul>
                  </div>
                </div>
                <ul class="document-list" *ngIf="allDocuments.docs3a.docs.length">
                  <li *ngFor="let doc of allDocuments.docs3a.docs">
                    <div class="document-list-date">{{ getFormatedDate(doc.attributes.document_date) }}</div>
                    <a download (click)="download3ADocs(doc)">
                      <span>{{ doc.attributes.document_type }}</span>
                      @if(doc?.attributes?.document_external_url) {
                        <span class="icon-i-link"></span>
                      } @else {
                        <span class="icon-i-download"></span>
                      }
                    </a>
                  </li>
                </ul>
              </div>

              <app-pagination
                *ngIf="allDocuments.docs3a.docs.length && allDocuments.docs3a.pages > 1 && activeTab === '3a'"
                [currentPage]="allDocuments.docs3a.pageIndex"
                [pages]="allDocuments.docs3a.pages"
                [pagesSelectionOptions]="pagesSelectionOptions"
                (update)="updatePagination($event)"
              ></app-pagination>

              <!-- grow -->
              <div class="white-box" *ngIf="activeTab === 'grow'">
                <ng-container *ngIf="allDocuments.docsGrow.length > 0; else showEmptyMessage">
                  <div class="document-list-group" *ngFor="let project of allDocuments.docsGrow.projects">
                    <div class="title">
                      <span>{{ project.title }}</span>
                    </div>
                    <ul class="document-list">
                      <li *ngFor="let doc of project.documents">
                        <a href="{{ doc.filename }}" target="_blank">
                          <span>{{ doc.title }}</span>
                          <span class="icon-i-download"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-container>
                <ng-template #showEmptyMessage> {{ 'profile.documents.empty_documents' | translate }} </ng-template>
              </div>
            </ng-template>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</section>
